/* Loft Home — product card image strip: dots follow swipe/scroll, dots scroll the strip, hover plays through the images. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function sync(track) {
    var dots = track._pcxDots; if (!dots) return;
    var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === i);
  }
  function bind(root) {
    var tracks = (root || document).querySelectorAll('[data-pcx-track]');
    for (var t = 0; t < tracks.length; t++) {
      var track = tracks[t];
      if (track._pcx) continue; track._pcx = true;
      var box = track.closest('[data-pcx-gallery]');
      track._pcxDots = box ? box.querySelectorAll('[data-pcx-dot]') : null;
      if (!track._pcxDots || !track._pcxDots.length) continue;
      track.addEventListener('scroll', (function (tr) { var raf = 0; return function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(tr); }); }; })(track), { passive: true });
    }
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('[data-pcx-dot]');
    if (!dot) return;
    e.preventDefault(); e.stopPropagation();
    var box = dot.closest('[data-pcx-gallery]'), track = box && box.querySelector('[data-pcx-track]');
    if (!track) return;
    track.scrollTo({ left: track.clientWidth * (+dot.getAttribute('data-pcx-dot')), behavior: reduce ? 'auto' : 'smooth' });
  });
  /* Stop a horizontal swipe on the strip from following the product link */
  document.addEventListener('click', function (e) {
    var tr = e.target.closest && e.target.closest('[data-pcx-track]');
    if (tr && tr._pcxDragged) { e.preventDefault(); tr._pcxDragged = false; }
  }, true);
  document.addEventListener('pointerdown', function (e) { var tr = e.target.closest && e.target.closest('[data-pcx-track]'); if (tr) { tr._pcxX = tr.scrollLeft; } }, { passive: true });
  document.addEventListener('pointerup', function (e) { var tr = e.target.closest && e.target.closest('[data-pcx-track]'); if (tr && Math.abs(tr.scrollLeft - (tr._pcxX || 0)) > 8) tr._pcxDragged = true; }, { passive: true });
  /* Hover slideshow (mouse only): while the pointer is over the photo, step to the next image
     every 1.2s; go back to the first image when the pointer leaves. */
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  function go(track, i, smooth) {
    var slides = track.children.length; if (slides < 2) return;
    track._pcxI = (i + slides) % slides;
    var img = track.children[track._pcxI] && track.children[track._pcxI].querySelector('img');
    if (img && img.loading === 'lazy') img.loading = 'eager';
    track.scrollTo({ left: track.clientWidth * track._pcxI, behavior: smooth && !reduce ? 'smooth' : 'auto' });
  }
  function start(track) {
    if (!canHover.matches || track.children.length < 2) return;
    clearTimeout(track._pcxT); clearInterval(track._pcxTimer);
    for (var k = 0; k < Math.min(2, track.children.length); k++) { var im = track.children[k].querySelector('img'); if (im && im.loading === 'lazy') im.loading = 'eager'; }
    track._pcxI = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    track._pcxT = setTimeout(function () {
      go(track, track._pcxI + 1, true);
      track._pcxTimer = setInterval(function () { go(track, track._pcxI + 1, true); }, 1200);
    }, 350);
  }
  function stop(track) {
    clearTimeout(track._pcxT); clearInterval(track._pcxTimer);
    if (track.scrollLeft > 0) go(track, 0, true);
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    /* The card's title link stretches over the whole card (::after), so listen on the card, not the photo */
    var box = e.target.closest && e.target.closest('.pcx'); if (!box || box._pcxHover) return;
    var track = box.querySelector('[data-pcx-track]'); if (!track) return;
    box._pcxHover = true; start(track);
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var box = e.target.closest && e.target.closest('.pcx'); if (!box || !box._pcxHover) return;
    if (e.relatedTarget && box.contains(e.relatedTarget)) return;
    box._pcxHover = false;
    var track = box.querySelector('[data-pcx-track]'); if (track) stop(track);
  });
  /* A dot click pauses the hover slideshow on the chosen image */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('[data-pcx-dot]'); if (!dot) return;
    var box = dot.closest('[data-pcx-gallery]'), track = box && box.querySelector('[data-pcx-track]');
    if (track) { clearTimeout(track._pcxT); clearInterval(track._pcxTimer); track._pcxI = +dot.getAttribute('data-pcx-dot'); }
  }, true);

  bind();
  if ('MutationObserver' in window) new MutationObserver(function () { bind(); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
